export const FETCH_OFFERS = 'OFFERS/FETCH_OFFERS';
export const FETCH_OFFER = 'OFFERS/FETCH_OFFER';
export const SET_LOADER = 'OFFERS/SET_LOADER';
export const FETCH_OFFER_GOODS = 'OFFERS/FETCH_OFFER_GOODS';
export const SET_PAGE = 'OFFERS/SET_PAGE';
export const FETCH_FILTERS = 'OFFERS/FETCH_FILTERS';
export const SET_OFFER_LOADER = 'OFFERS/SET_OFFER_LOADER';
